import * as Yup from 'yup-v5';
import "./yup/yupSchema.d.ts";

export default Yup;